import { formatDate, formatDateISO } from '@helpers/date';
import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './MediaCard.styles';
const MediaCard = ({ countIndex = 1, countTotal = 1, date, image, linkText = 'Read more', summary, tag, title, url, video = false, fullHeight = false }) => {
    return (React.createElement(S.Container, { "data-full-height": fullHeight, "aria-label": countTotal ? `slide ${countIndex + 1} of ${countTotal}` : '', "data-image": image != undefined ? true : false },
        React.createElement(S.Link, { draggable: false, href: url, "aria-label": linkText },
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: image.altText, draggable: false, loading: "lazy", src: imageUrl(image, { width: 560, dpr: 1 }), srcSet: [
                        `${imageUrl(image, { width: 560, dpr: 1 })} 1x`,
                        `${imageUrl(image, { width: 560, dpr: 1.5 })} 1.5x`,
                        `${imageUrl(image, { width: 560, dpr: 2 })} 2x`,
                    ].join(', ') }),
                video && (React.createElement(S.PlayButton, null,
                    React.createElement(S.PlayIcon, null))))),
            !fullHeight && (React.createElement(S.ContentWrapper, null,
                (date || tag) && (React.createElement(S.Metadata, null,
                    tag && React.createElement(S.Badge, { ...tag }),
                    date && React.createElement(S.Date, { dateTime: formatDateISO(date) }, formatDate(date)))),
                React.createElement(S.Title, null, title),
                summary && React.createElement(S.Summary, null, summary),
                React.createElement(S.Cta, null, linkText))))));
};
export default MediaCard;
